module.exports = __webpack_public_path__ + "static/media/logo_cn_fr.c424bd1e.svg";